import { render, staticRenderFns } from "./FinancialSanctionsCheck.vue?vue&type=template&id=faf5ae8a&scoped=true"
import script from "./FinancialSanctionsCheck.vue?vue&type=script&lang=js"
export * from "./FinancialSanctionsCheck.vue?vue&type=script&lang=js"
import style0 from "./FinancialSanctionsCheck.vue?vue&type=style&index=0&id=faf5ae8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf5ae8a",
  null
  
)

export default component.exports